'use strict';

/**
 *  Load modules
 */
import "core-js/stable";
import "regenerator-runtime/runtime";
import menu from './modules/menu.js';
import servicesSlider from './modules/services-slider.js';
import projectsSlider from './modules/projects-slider.js';
import vacancies from "./modules/vacancies.js";

import '../scss/app.scss';

$(document).ready(() => {


    document.addEventListener('showDropdown', function (e) {
        const container = e.target;

        const scrollY = window.scrollY;

        requestAnimationFrame(() => {
            window.scrollTo(0, scrollY);
        });
    });

    document.addEventListener('showDropdown', function (e) {
        const highlighted = e.target.querySelector('.is-highlighted');

        if (highlighted) {
            highlighted.classList.remove('is-highlighted');
        }
    });

    document.querySelectorAll('.wpcf7 select').forEach(select => {
        select.choicesInstance = new Choices(select, {
            searchEnabled: false,
            shouldSort: false,
            resetScrollPosition: false,
            position: 'bottom',
            itemSelectText: '',
            renderSelectedChoices: 'always',
        });
    });

    menu();
    servicesSlider();
    projectsSlider();
    vacancies();

    $('.resume')
        .siblings('.codedropz-upload-handler')
        .find('.cd-upload-btn')
        .text('Datei auswählen');

    const scrollTopBtn = document.querySelector('.scroll-top');
    const scrollTopLogo = document.querySelectorAll('.to-top');

    if (scrollTopLogo) {


        scrollTopLogo.forEach(item => {
            item.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        });
    }

    if (scrollTopBtn) {

        scrollTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });


        window.addEventListener('scroll', () => {
            if (window.scrollY > 300) {
                scrollTopBtn.classList.add('visible');
            } else {
                scrollTopBtn.classList.remove('visible');
            }
        });

    }

    const menuItems = document.querySelectorAll('.menu-item');

    const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');

    anchorLinks.forEach(link => {
        link.addEventListener('click', function (e) {

            const target = document.querySelector(this.hash);

            if (!target) return;

            e.preventDefault();

            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    });

    const sections = [...document.querySelectorAll('section[id]')];

    function updateActiveMenu() {
        const headerHeight = document.querySelector('.header-wrapper').offsetHeight;

        const line = headerHeight + 20;

        let current = sections[0].id;

        sections.forEach(section => {
            const rect = section.getBoundingClientRect();

            if (rect.top <= line) {
                current = section.id;
            }
        });

        menuItems.forEach(item => item.classList.remove('active'));

        const activeLink = document.querySelector(
            `.menu-item a[href="#${current}"]`
        );

        activeLink?.closest('.menu-item')?.classList.add('active');
    }

    window.addEventListener('scroll', updateActiveMenu);
    window.addEventListener('load', updateActiveMenu);

    document.addEventListener('click', function (e) {

        const btn = e.target.closest('.hero__content-campaign-button');
        if (!btn) return;

        e.preventDefault();

        const value = btn.dataset.value;
        const select = document.querySelector('select[name="position"]');

        if (!select || !select.choicesInstance) return;

        select.choicesInstance.setChoiceByValue(value);

        document.querySelector('#wpcf7-f6-o1').scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });

    });

});

$(window).on('load', () => {

    AOS.init({
        once: true
    });

    if (typeof AOS.refreshHard === 'function') {
        AOS.refreshHard();
    }
});
